module.exports = __webpack_public_path__ + "img/orange_084.132d1b6a.png";